if (!customElements.get('ct-product-faq')) {
  customElements.define('ct-product-faq', class extends HTMLElement {
    connectedCallback() {
      this.align = () => {
        const product = document.querySelector('product-component.ct-pdp--narrow');
        const width = product && getComputedStyle(product).getPropertyValue('--ctPdpMax').trim();
        if (width) this.style.setProperty('--ctFaqMax', width);
        else this.style.removeProperty('--ctFaqMax');
      };
      this.animations = new Map();
      this.onClick = event => {
        const summary = event.target.closest('summary.ct-product-faq__question');
        if (!summary || !this.contains(summary) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        event.preventDefault();
        const item = summary.parentElement;
        const previous = this.animations.get(item);
        const opening = previous ? !previous.opening : !item.open;
        const start = item.getBoundingClientRect().height;
        if (previous) { previous.animation.onfinish = null; previous.animation.cancel(); }
        item.open = true;
        item.toggleAttribute('data-closing', !opening);
        const end = opening ? item.scrollHeight : summary.getBoundingClientRect().height;
        const animation = item.animate([{height: start + 'px'}, {height: end + 'px'}], {duration: 340, easing: 'cubic-bezier(.22,1,.36,1)'});
        this.animations.set(item, {animation, opening});
        animation.onfinish = () => {
          item.open = opening;
          item.removeAttribute('data-closing');
          this.animations.delete(item);
        };
      };
      this.addEventListener('click', this.onClick);
      this.align();
      document.addEventListener('shopify:section:load', this.align);
    }
    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this.align);
      this.removeEventListener('click', this.onClick);
      this.animations?.forEach(({animation, opening}, item) => {
        animation.onfinish = null;
        animation.cancel();
        item.open = opening;
        item.removeAttribute('data-closing');
      });
      this.animations?.clear();
    }
  });
}
